import React, { useState } from 'react';
import { css } from '@emotion/react';
import { TextField } from '@material-ui/core';
import NavResponsiveModal, { ModalHeader } from '@/components/Navigation/NavResponsiveModal';
import { ModalContent, PrimaryButton, SecondaryButton } from '@/styles/blocks';
import { DECISIONS } from './utils';

/**
 * Confirms an Approve or Deny on one document, with an optional note.
 *
 * @param {{ title: string, decision: 'APPROVED'|'DENIED', saving: boolean, onSubmit: (note: string) => void,
 *   onClose: () => void }} props
 */
const ReviewDocumentModal = ({ title, decision, saving, onSubmit, onClose }) => {
    const [note, setNote] = useState('');
    const { verb } = DECISIONS[decision];

    return (
        <NavResponsiveModal open onClose={onClose} maxWidth="sm" fullWidth>
            <ModalHeader
                title={`${verb} ${title}`}
                onClose={onClose}
                css={css`
                    border-bottom: 1px solid lightgray;
                `}
            />
            <ModalContent
                css={css`
                    width: 100%;
                `}
            >
                <TextField
                    label="Notes"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={4}
                    value={note}
                    onChange={(event) => setNote(event.target.value)}
                    placeholder={decision === 'DENIED' ? 'What does the carrier need to fix?' : 'Optional'}
                />
                <div
                    css={css`
                        display: flex;
                        justify-content: space-between;
                        margin-top: 24px;
                    `}
                >
                    <SecondaryButton disabled={saving} onClick={onClose}>
                        Cancel
                    </SecondaryButton>
                    <PrimaryButton
                        red={decision === 'DENIED'}
                        loading={saving}
                        disabled={saving}
                        onClick={() => onSubmit(note.trim())}
                    >
                        {verb}
                    </PrimaryButton>
                </div>
            </ModalContent>
        </NavResponsiveModal>
    );
};

export default ReviewDocumentModal;
